import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import store from "./store";
import url from "./plugins/urls";
// import axios from "axios";
import utils from "./plugins/utility";
import { VueCookieNext } from "vue-cookie-next";
import http from "./config.js";
import NotFound from "./components/404NotFound.vue";

import VCalendar from "v-calendar";
import "v-calendar/style.css";
loadFonts();
const app = createApp(App);

app.provide("url", url);
app.provide("utils", utils);
app.provide("http", http);
app.use(VueCookieNext);
app.component("none-layout", NotFound);

// app.config.globalProperties.$http = axios;
// app.config.globalProperties.hostname = url;
// app.config.globalProperties.$store = store;
app.use(router).use(store).use(vuetify).use(VCalendar, {}).mount("#app");
